import { Actions } from './store';
import { CaseError } from 'modules/cm/domain/Case/Error';
import { Nullable } from 'utils/types';

export const setError = (error: Nullable<CaseError>) => ({
  type: Actions.SET_ERROR,
  payload: error,
});
